import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

const getRecordFromFirestore = async (collectionName, campoName, campoValue) => {
  const db = getFirestore(firebaseApp);
  
  try {
    console.log(`🔍 Buscando en ${collectionName} donde ${campoName} = ${campoValue}`);
    
    // Primera búsqueda con el valor original
    let q = query(collection(db, collectionName), where(campoName, '==', campoValue));
    let querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const record = querySnapshot.docs[0].data();
      console.log('✅ Registro encontrado con valor original:', record);
      return record;
    }

    // Si es un campo email y no se encontró, intentar con diferentes formatos
    if (campoName === 'email' && typeof campoValue === 'string') {
      console.log('⚠️ No se encontró con valor original, probando diferentes formatos de email...');
      
      // Intentar con minúsculas
      const emailMinusculas = campoValue.toLowerCase().trim();
      if (emailMinusculas !== campoValue) {
        console.log(`🔍 Intentando con minúsculas: ${emailMinusculas}`);
        q = query(collection(db, collectionName), where(campoName, '==', emailMinusculas));
        querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const record = querySnapshot.docs[0].data();
          console.log('✅ Registro encontrado con minúsculas:', record);
          return record;
        }
      }

      // Intentar con mayúsculas
      const emailMayusculas = campoValue.toUpperCase().trim();
      if (emailMayusculas !== campoValue && emailMayusculas !== emailMinusculas) {
        console.log(`🔍 Intentando con mayúsculas: ${emailMayusculas}`);
        q = query(collection(db, collectionName), where(campoName, '==', emailMayusculas));
        querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const record = querySnapshot.docs[0].data();
          console.log('✅ Registro encontrado con mayúsculas:', record);
          return record;
        }
      }

      // Intentar con el formato como está almacenado (normalizado)
      const emailNormalizado = campoValue.trim();
      if (emailNormalizado !== campoValue) {
        console.log(`🔍 Intentando con email normalizado: ${emailNormalizado}`);
        q = query(collection(db, collectionName), where(campoName, '==', emailNormalizado));
        querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const record = querySnapshot.docs[0].data();
          console.log('✅ Registro encontrado con email normalizado:', record);
          return record;
        }
      }
    }

    console.log('❌ No se encontró ningún registro que coincida con ningún formato');
    return null;

  } catch (error) {
    console.error('❌ Error al obtener el registro:', error);
    throw error;
  }
};

/* Uso de la función getRecordFromFirestore
const collectionName = 'users';
const fieldName = 'email';
const fieldValue = 'example@example.com';

getRecordFromFirestore(collectionName, fieldName, fieldValue);*/

export default getRecordFromFirestore;